import { render, staticRenderFns } from "./TypeView.vue?vue&type=template&id=6617f356&"
import script from "./TypeView.vue?vue&type=script&lang=js&"
export * from "./TypeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports